import React, { useEffect, useState, useRef } from "react";
import { Colors } from "../Colors/Colors";
import { hapticsImpactLight, mapWithFallback } from "../../../lib/utils";
import myLeague from "../../../assets/imgs/my_league.svg";
export interface TabItem {
  id: number;
  name: any;
}

interface TableTabsProps {
  tabItems: TabItem[];
  onTabSelect: (selectedTab: TabItem) => void;
  tabCustomStyle?: string;
  selectedTabStyle?: string;
  unselectedTabStyle?: string;
  renderTabText?: (item: TabItem) => string;
  resetTabs?: boolean;
  InicialselectedTab?: TabItem;
  showLeagueButton?: any;
}

const NewsChildTabs: React.FC<TableTabsProps> = ({
  tabItems,
  onTabSelect,
  tabCustomStyle = "",
  selectedTabStyle = "",
  unselectedTabStyle = "",
  renderTabText = (item) => item.name,
  resetTabs = false,
  InicialselectedTab = null,
  showLeagueButton,
}) => {
  const [selectedTab, setSelectedTab] = useState<TabItem | null>(
    InicialselectedTab,
  );
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (resetTabs) {
      setSelectedTab(null);
    }
  }, [resetTabs]);

  useEffect(() => {
    setSelectedTab(InicialselectedTab);
    // Scroll to selected tab when it changes externally
    if (InicialselectedTab) {
      const index = tabItems.findIndex(tab => tab.id === InicialselectedTab.id);
      if (index >= 0) {
        scrollTabIntoView(index);
      }
    }
  }, [InicialselectedTab]);

  const scrollTabIntoView = (index: number) => {
    if (containerRef.current && tabRefs.current[index]) {
      const container = containerRef.current;
      const tabElement = tabRefs.current[index];
      
      // Scroll the tab to the leftmost position, accounting for the 12px left padding of spacer
      if (tabElement) {
        container.scrollTo({
          left: tabElement.offsetLeft - container.offsetLeft - 12, // Subtract 12px for the left padding
          behavior: 'smooth'
        });
      }
    }
  };

  const handleTabClick = (tab: TabItem, index: number) => {
    setSelectedTab(tab);
    onTabSelect(tab);
    scrollTabIntoView(index);
  };

  return (
    <div className="flex gap-[12px] overflow-x-auto no-scrollbar scroll-smooth" ref={containerRef}>
      {/* Add invisible spacer element to ensure first tab has left margin */}
      <div className="w-[0px] flex-shrink-0"></div>
      {mapWithFallback(tabItems).map((tab, index) => {
        const isSelected = selectedTab?.name === tab.name;
        const isDefault = index === 0 && !selectedTab;

        const TextColor = isSelected || isDefault ? "#00E0FF" : "#FFFFFF";
        const bgColor = isSelected || isDefault ? "#08262A" : "#1C1C1A";

        return (
          <div
            key={tab.id}
            ref={el => (tabRefs.current[index] = el)}
            onClick={() => handleTabClick(tab, index)}
            className={`rounded-[31.05px] p-[11.5px] flex justify-center items-center text-[13.8px] font-medium cursor-pointer w-fit ${tabCustomStyle}`}
            style={{ color: TextColor, backgroundColor: bgColor }}
          >
            {renderTabText(tab)}
          </div>
        );
      })}
      {/* Add invisible spacer element to ensure last tab is fully visible */}
      <div className="w-1 flex-shrink-0"></div>
    </div>
  );
};

export default NewsChildTabs;
